<template>
  <div class="event-diplomas">
    <modal :title="'Отправить грамоты / дипломы'" :subtitle="'Всего 350 человек'"
      v-on:close="switchModal"
      v-if="modal">
      <div class="ccs-layout">
        <div class="ccs-input ccs-5">
          <label class="ccs-input__label">Выберите шаблон</label>
          <input type="text" class="ccs-input__field" placeholder="Выберите шаблон">
          <img src="@/assets/icons/dropdown_arrow.svg" alt="" class="ccs-input__icon">
        </div>
        <div class="ccs-input ccs-2">
          <label class="ccs-input__label">Дата на шаблоне</label>
          <input type="text" class="ccs-input__field" placeholder="03 / 10 / 2014">
          <img src="@/assets/icons/calendar_blue.svg" alt="" class="ccs-input__icon">
        </div>
        <div class="ccs-layout ccs-layout--no-pad">
          <div>
            <button class="ccs-button">
              Отправить
            </button>
          </div>
          <div>
            <button class="ccs-button ccs-button--light" @click="switchModal">
              Отмена
            </button>
          </div>
        </div>
      </div>
    </modal>
    <div class="diplomas-actions">
      <div class="ccs-input">
        <input type="text" class="ccs-input__field"
          placeholder="Найти участника">
        <img src="@/assets/icons/search.svg" alt="" class="ccs-input__icon">
      </div>
      <div class="actions-group">
        <button class="ccs-button ccs-button--white ccs-button--small">
          <img src="@/assets/icons/add.svg" alt="" class="button-icon">
          Создать шаблон
        </button>
        <button class="ccs-button ccs-button--white ccs-button--small" @click="switchModal">
          <img src="@/assets/icons/certificate.svg" alt="" class="button-icon" height="20px">
          Отправить выделенным
        </button>
      </div>
    </div>
    <div class="user-select">
      <div class="header"></div>
      <div class="row">
        <label>
          <input type="checkbox">
          <span class="checkmark"></span>
        </label>
        <details>
          <summary @click.prevent="" class="summary-status">
            Участники
            <div class="summary-actions">
              <img src="@/assets/icons/certificate.svg" alt=""
                class="button-icon" height="20px">
              <img src="@/assets/icons/details_arrow.svg" alt=""
                class="button-icon" @click="openDetails">
            </div>
          </summary>
          <div class="row">
            <label>
              <input type="checkbox" checked>
              <span class="checkmark"></span>
            </label>
            <details>
              <summary @click.prevent="" class="summary-competence">
                17 WSI Веб дизайн и разработка
                <div class="summary-actions">
                  <img src="@/assets/icons/certificate.svg" alt=""
                    class="button-icon" height="20px">
                  <img src="@/assets/icons/details_arrow.svg" alt=""
                    class="button-icon" @click="openDetails">
                </div>
              </summary>
              <div class="row">
                <label>
                  <input type="checkbox" checked>
                  <span class="checkmark"></span>
                </label>
                <details>
                  <summary @click.prevent="" class="summary-user">
                    <div class="fullname">
                      <i class="surname">Стогов</i>
                      Евгений Александрович
                    </div>
                    <div class="email">
                      long_template@template.ru
                    </div>
                    <div class="mobile_number">
                      +7-926-123-45-67
                    </div>
                    <div class="location">
                      Москва
                    </div>
                    <div class="summary-actions">
                      <img src="@/assets/icons/certificate.svg" alt=""
                        class="button-icon" height="20px">
                    </div>
                  </summary>
                </details>
              </div>
            </details>
          </div>
        </details>
      </div>
      <div class="row">
        <label>
          <input type="checkbox">
          <span class="checkmark"></span>
        </label>
        <details>
          <summary @click.prevent="">
            Эксперты
            <div class="summary-actions">
              <img src="@/assets/icons/certificate.svg" alt=""
                class="button-icon" height="20px">
              <img src="@/assets/icons/details_arrow.svg" alt=""
                class="button-icon" @click="openDetails">
            </div>
          </summary>
        </details>
      </div>
      <div class="row">
        <label>
          <input type="checkbox">
          <span class="checkmark"></span>
        </label>
        <details>
          <summary @click.prevent="">
            Спонсоры
            <div class="summary-actions">
              <img src="@/assets/icons/certificate.svg" alt=""
                class="button-icon" height="20px">
              <img src="@/assets/icons/details_arrow.svg" alt=""
                class="button-icon" @click="openDetails">
            </div>
          </summary>
        </details>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from '../../components/Modal.vue';

export default {
  name: 'Diplomas',
  components: {
    Modal,
  },
  data() {
    return {
      modal: false,
    };
  },
  methods: {
    switchModal() {
      this.modal = !this.modal;
    },
    openDetails(e) {
      // eslint-disable-next-line
      e.target.parentElement.parentElement.parentElement.open = !e.target.parentElement.parentElement.parentElement.open;
    },
  },
};
</script>

<style lang="scss" scoped>
.event-diplomas {
  min-height: 100%;
  min-width: 100%;

  .diplomas-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .actions-group {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      > button:first-child {
        margin-right: 12px;
      }

    }

  }

  .user-select {
    margin-top: 18px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    overflow: hidden;

    .header {
      height: 32px;
      border-radius: 5px 5px 0 0;
      background: $neutralLightest;
    }

    .row {
      position: relative;
      min-height: 45px;
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      > details {
        padding-left: 49px;
        flex: 1;

        &[open] {

          > summary > .summary-actions {

            img:last-child {
              transform: rotate(-90deg);
            }

          }

        }

        > summary {
          position: relative;
          height: 45px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          font-size: 14px;
          color: $surfaceDarker;

          &:after {
            content: '';
            position: absolute;
            left: -100px;
            bottom: 0;
            width: 100vw;
            border-bottom: 1px solid #D8DDEF;
          }

          &::-webkit-details-marker {
            display: none;
          }

          .summary-actions {
            margin: 0 16px 0 auto;
            justify-self: flex-end;

            > img:hover {
              cursor: pointer;
            }

            > img:nth-child(2) {
              margin-left: 18px;
              transition: transform ease-in-out .2s;
            }

          }

        }

      }

      > label {

        > input[type=checkbox] {
          margin: 0 16px 4px 0;
          position: absolute;
          opacity: 0;
          cursor: pointer;
          height: 0;
          width: 0;
        }

        .checkmark {
          position: absolute;
          top: 12px;
          left: 15px;
          height: 17px;
          width: 17px;
          border: 1px solid #000000;
          border-radius: 3px;

          &:after {
            content: "";
            position: absolute;
            display: none;
          }

        }

        &:hover input ~ .checkmark {
          background-color: $neutralLightest;
        }

        > input:checked ~ .checkmark {
          background-color: $primary;
        }

        > input:checked ~ .checkmark:after {
          display: block;
        }

        .checkmark:after {
          left: 6px;
          top: 2px;
          width: 3px;
          height: 8px;
          border: solid white;
          border-width: 0 3px 3px 0;
          -webkit-transform: rotate(45deg);
          -ms-transform: rotate(45deg);
          transform: rotate(45deg);
        }

      }

    }

  }

  .summary-user {

    .fullname {
      width: 300px;

      .surname {
        font-weight: bold;
      }

    }

    .email {
      width: 200px;
      font-size: 12px;
      color: $neutralLight;
      overflow: hidden;
    }

    .mobile_number {
      width: 150px;
      overflow: hidden;
    }

    .location {
      width: 200px;
      overflow: hidden;
    }

    > div:not(:first-child) {
      margin-left: 50px;
    }

  }

}
</style>
